export default __webpack_public_path__ + "static/media/instagram_icon.0b88f0e6.svg";